var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { flatten } from 'lodash';
export function mergeSceneGraphNodes(_object1, _object2) {
    var objectIdsUniqueToNew = {};
    var objectIdsUniqueToOriginal = {};
    // merge lives in nested scope, so we can collect new object ids through each recursion.
    function merge(object1, object2) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
        if (object1.objectId !== object2.objectId) {
            objectIdsUniqueToNew[object2.objectId] = true;
            return [object1, object2];
        }
        // recursive merging won't happen if an object's objects are undefined.
        // need to look for unique objects here too.
        if (object1.objects === undefined && object2.objects) {
            try {
                for (var _e = __values(object2.objects), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var object = _f.value;
                    objectIdsUniqueToNew[object.objectId] = true;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return [__assign({}, object2)];
        }
        if (object1.objects && object2.objects === undefined) {
            try {
                for (var _g = __values(object1.objects), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var object = _h.value;
                    objectIdsUniqueToOriginal[object.objectId] = true;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return [__assign({}, object1)];
        }
        if (object1.objects === undefined && object2.objects === undefined) {
            return [__assign({}, object1)];
        }
        var objects = [];
        var _loop_1 = function (obj1) {
            var obj2 = object2.objects.find(function (o) { return o.objectId === obj1.objectId; });
            if (obj2) {
                objects.push(merge(obj1, obj2));
            }
            else {
                objectIdsUniqueToOriginal[obj1.objectId] = true;
                objects.push(obj1);
            }
        };
        try {
            // if an object exists in both groups, it needs to be merged recursively
            // if not, it can simply be appended.
            for (var _j = __values(object1.objects), _k = _j.next(); !_k.done; _k = _j.next()) {
                var obj1 = _k.value;
                _loop_1(obj1);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var _loop_2 = function (obj2) {
            var obj1 = object1.objects.find(function (o) { return o.objectId === obj2.objectId; });
            if (!obj1) {
                objectIdsUniqueToNew[obj2.objectId] = true;
                objects.push(obj2);
            }
        };
        try {
            // must compare the other way, to find objects in group 2 that aren't in group 1.
            for (var _l = __values(object2.objects), _m = _l.next(); !_m.done; _m = _l.next()) {
                var obj2 = _m.value;
                _loop_2(obj2);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
            }
            finally { if (e_4) throw e_4.error; }
        }
        // don't mutate
        var _obj = __assign({}, object1);
        // collect the objects we found recursively
        _obj.objects = flatten(objects);
        return [_obj];
    }
    var root = merge(_object1, _object2);
    return {
        root: root,
        objectIdsUniqueToNew: objectIdsUniqueToNew,
        objectIdsUniqueToOriginal: objectIdsUniqueToOriginal
    };
}
